import { memo, useState } from "react";
import Hero from "../components/AboutUs/Hero";
import History from "../components/AboutUs/History";
import Team from "../components/AboutUs/Team";
import Benefits from "../components/AboutUs/Benefits";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useImagePreloader from "../hooks/useImagePreloader";
import LoadingOverlay from "../components/LoadingOverlay";

import aboutUsHeroImage from "/images/AboutUs/Hero.webp";
import historyImage from "/images/AboutUs/AboutUsHistory.webp";
import evgeniImage from "/images/AboutUs/Evgeni.webp";
import ilijaImage from "/images/AboutUs/Ilija.webp";
import ilkoImage from "/images/AboutUs/Ilko.webp";

import customerFirstIcon from "/images/AboutUs/Customer_first_white.svg";
import efficiencyIcon from "/images/AboutUs/Efficiently_white.svg";
import excellenceIcon from "/images/AboutUs/Excellence_white.svg";
import reliabilityIcon from "/images/AboutUs/Reliability_white.svg";
import sustainabilityIcon from "/images/AboutUs/Sustainability_white.svg";

const AboutUs = memo(function AboutUs() {
  const [selectedYear, setSelectedYear] = useState(2004);
  useDocumentTitle("about");

  const imagesToLoad = [
    aboutUsHeroImage,
    historyImage,
    evgeniImage,
    ilijaImage,
    ilkoImage,
    customerFirstIcon,
    efficiencyIcon,
    excellenceIcon,
    reliabilityIcon,
    sustainabilityIcon,
  ];

  const loading = useImagePreloader(imagesToLoad);

  const teamImages = {
    evgeni: evgeniImage,
    ilija: ilijaImage,
    ilko: ilkoImage,
  };

  const benefitIcons = {
    customerFirst: customerFirstIcon,
    efficiency: efficiencyIcon,
    excellence: excellenceIcon,
    reliability: reliabilityIcon,
    sustainability: sustainabilityIcon,
  };

  return (
    <>
      {loading && <LoadingOverlay />}
      <main>
        <Hero heroImage={aboutUsHeroImage} />
        <History
          historyImage={historyImage}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
        />
        <Benefits benefitIcons={benefitIcons} />
        <Team teamImages={teamImages} />
      </main>
    </>
  );
});

export default AboutUs;
